// HELPERS
import create_readable_id from "./create_readable_id";
import get_file_width_height from "./get_file_width_height";
import { create_asset_filename } from "./create_asset_filename";
// LIBS
import { s3_signed_url, s3_media_upload } from "../libs/amplify";
// ASSETS
import studio_config from "../configs/studio.json";
import { Google_Analytics_Event } from "../libs/google-analytics";

export default async function add_button_logo({ file, teamId, creativeId, creativeDispatch, formatType, mimeType, name, notificationDispatch, mediaLoadingDispatch }) {
  let fileName = create_asset_filename({ name, backupFileName: "buttonlogo" });
  let fileId = create_readable_id(4);
  try {
    mediaLoadingDispatch({ type: "UPDATE_PROGRESS", payload: { progress: Math.floor(Math.random() * (20 - 11 + 1) + 11) } });

    /////////////////////////////////////////////
    // ERROR HANDLING
    /////////////////////////////////////////////
    //
    // If no format exists, exit the process
    //
    if (!formatType) {
      throw new Error("No format chosen");
    }
    //
    // If no file exists, exit the upload process
    //
    if (!file) {
      throw new Error("No file found");
    }
    //
    // If unsupported mimetype
    //
    if (!mimeType.includes("image")) {
      throw new Error("Unsupported file type detected. Please use PNG or JPG files.");
    }
    //
    // If unsupported file format
    //
    if (!studio_config.formats[formatType].buttonLogo.acceptedMimeTypes.includes(mimeType)) {
      throw new Error("Unsupported image format detected. Please use PNG or JPG files.");
    }
    //
    // If file size = 0 ) (usually when trying to upload an un-synced file), exit the upload process
    //
    if (file.size === 0) {
      throw new Error("File has missing data. Please check file before uploading.");
    }
    Google_Analytics_Event({ name: "add_buttonlogo_start", category: "media", action: "upload", label: fileName });
    /////////////////////////////////////////////
    // CREATE & UPLOAD ORIGINAL FILES
    /////////////////////////////////////////////
    let dimensions = await get_file_width_height(file, mimeType);
    let originalS3Upload = await s3_media_upload({
      fileKey: `${fileName}-${fileId}-original.${mimeType.split("/")[1]}`,
      mimeType,
      body: file,
      teamId,
      creativeId,
    });
    mediaLoadingDispatch({ type: "UPDATE_PROGRESS", payload: { progress: Math.floor(Math.random() * (40 - 21 + 1) + 21) } });

    //
    // no initial cropping needs to take place for the button logo asset
    // but we need to save another copy in s3 as this will be used for future cropping
    //
    let croppedS3Upload = await s3_media_upload({
      fileKey: `${fileName}-${fileId}-cropped.${mimeType.split("/")[1]}`,
      mimeType,
      body: file,
      teamId,
      creativeId,
    });
    mediaLoadingDispatch({ type: "UPDATE_PROGRESS", payload: { progress: Math.floor(Math.random() * (90 - 41 + 1) + 41) } });

    let originalUrl = await s3_signed_url({ teamId, creativeId, fileName: originalS3Upload.fileName });
    let croppedUrl = await s3_signed_url({ teamId, creativeId, fileName: croppedS3Upload.fileName });
    //
    // RETURN IF MEDIA LOADING IS CANCELLED
    // Tertiary call after files have been created on server
    //
    // if (mediaLoading.isCancelled) {
    //   mediaLoadingDispatch({ type: "UPDATE_LOADING_STATE", payload: { status: false, type: "", message: "", isCancelled: false } });
    //   return;
    // }
    Google_Analytics_Event({ name: "add_buttonlogo_success", category: "media", action: "upload", label: fileName });

    /////////////////////////////////////////////
    // UPDATE CONTEXT
    /////////////////////////////////////////////
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_DIMENSIONS_WIDTH",
      payload: { width: dimensions.width },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_DIMENSIONS_HEIGHT",
      payload: { height: dimensions.height },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_CROPPEDAREAPIXELS_WIDTH",
      payload: { width: dimensions.width },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_CROPPEDAREAPIXELS_HEIGHT",
      payload: { height: dimensions.height },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_CROPPEDAREAPIXELS_X",
      payload: { x: 0 },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_CROPPEDAREAPIXELS_Y",
      payload: { y: 0 },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_ZOOM",
      payload: { zoom: 1 },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_MIMETYPE",
      payload: { mimeType },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_ID",
      payload: { id: fileId },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_FILENAME",
      payload: { fileName },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_BODYORIGINAL",
      payload: { bodyOriginal: originalUrl },
    });
    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_BUTTON_LOGO_BODYCROPPED",
      payload: { bodyCropped: croppedUrl },
    });
  } catch (error) {
    Google_Analytics_Event({ name: "add_buttonlogo_failure", category: "media", action: "upload", label: fileName });

    return notificationDispatch({
      type: "ADD",
      payload: {
        header: "Error uploading",
        message: error.message,
        type: "error",
        autoDismiss: true,
      },
    });
  }
}
